"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _mdiMaterialUi = require("mdi-material-ui");
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _Dropdown = _interopRequireDefault(require("./Dropdown.styles"));
var _excluded = ["value", "onChange", "onClick", "children", "disabled", "hideEndIcon", "placeholder", "startIcon", "fullWidth"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Dropdown = function Dropdown(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$hideEndIcon = _ref.hideEndIcon,
    hideEndIcon = _ref$hideEndIcon === void 0 ? false : _ref$hideEndIcon,
    placeholder = _ref.placeholder,
    startIcon = _ref.startIcon,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    props = _objectWithoutProperties(_ref, _excluded);
  // HOOKS
  var classes = (0, _Dropdown.default)();

  // EVENTS
  var handleClick = function handleClick(event) {
    if (onClick) {
      onClick(event);
    }
  };

  // STYLES
  var cssDropdown = (0, _classnames.default)(classes.dropdown, {
    selected: value,
    withIcon: startIcon,
    fullWidth: fullWidth
  });
  return /*#__PURE__*/_react.default.createElement(_core.Button, {
    "aria-controls": "dropdown",
    "aria-haspopup": "true",
    disabled: disabled,
    onClick: handleClick,
    endIcon: !hideEndIcon && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.ChevronDown, null),
    startIcon: startIcon,
    classes: {
      root: cssDropdown
    }
  }, value || placeholder);
};
var _default = Dropdown;
exports.default = _default;